import { lazy } from "react"
// project import
import Loadable from "components/Loadable"

const Loading = Loadable(lazy(() => import("pages/LoadingPage")))

// ==============================|| MAIN ROUTING ||============================== //

const LoadingRoutes = {
  path: "*",
  element: <Loading />,
}

export default LoadingRoutes
